import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";

import { useApiStore } from "@/store/hooks";
import { AllocationGroup } from "@/Models";

export const CONSTANTS = {
  SET_ALLOCATION_GROUPS_CACHE: "SET_ALLOCATION_GROUPS_CACHE",
};

const INITIAL_STATE = {
  allocationGroupsCache: [],
};

const reducer = (state, action) => {
  switch (action.type) {
    case CONSTANTS.SET_ALLOCATION_GROUPS_CACHE:
      return {
        ...state,
        allocationGroupsCache: action.allocationGroupsCache,
      };
    default:
      return INITIAL_STATE;
  }
};

export const Context = createContext(INITIAL_STATE);

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <Context.Provider value={{ dispatch, state }}>{children}</Context.Provider>
  );
};

export const useAllocationGroupsStore = () => {
  const api = useApiStore();
  const { dispatch, state } = useContext(Context);

  const fetchByPostalCode = useCallback(
    async ({ postalCode, corpUserId }) => {
      const query = {
        postalCode,
        corpUserId,
      };

      const allocationGroup = await api.get(`/allocation-groups/one`, query);

       const _allocationGroupsCache = [...state.allocationGroupsCache];

      if (_allocationGroupsCache.find((c) => c.id === allocationGroup.id && c.corpUserId === corpUserId && c.postalCode === postalCode)) {
        _allocationGroupsCache.splice(
          _allocationGroupsCache.findIndex((c) => c.id === allocationGroup.id),
          1,
          new AllocationGroup({
            ...allocationGroup,
            postalCode,
            corpUserId,
          }),
        );
      } else {
        _allocationGroupsCache.push(new AllocationGroup({
          ...allocationGroup,
          postalCode,
          corpUserId,
        }));
      }

      dispatch({
        type: CONSTANTS.SET_ALLOCATION_GROUPS_CACHE,
        allocationGroupsCache: _allocationGroupsCache,
      });

      return new AllocationGroup({
        ...allocationGroup,
        postalCode,
        corpUserId,
      });
    },
    [api.get, state.allocationGroupsCache],
  );

  return {
    state,
    fetchByPostalCode,
  };
};
